export const getToken = (): string | null => {
  return sessionStorage.getItem('accessToken') ?? null;
};

export const getExpiredTime = (): string | null => {
  return sessionStorage.getItem('expiredTime') ?? null;
};

export const setToken = (accessToken: string) => {
  return sessionStorage.setItem('accessToken', accessToken);
};

export const setTokenExpiredTime = (expiresIn: number) => {
  const expiredTime = Date.now() + expiresIn;
  return sessionStorage.setItem('expiredTime', expiredTime.toString());
};

export const removeToken = () => {
  return sessionStorage.removeItem('accessToken');
};
